export namespace Actions {
  export class Completed {
    static readonly type = "[ElectricalProductsFilter] Completed";
    constructor(public filter: string) {}
  }
}
